// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Loader_skeleton__3BVNE","content":"Loader_content__NeyvK","title":"Loader_title__DKwy3","rest":"Loader_rest__1gbVW"};